import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtDate } from "@/lib/helpers";
import { toast } from "sonner";
import { Check, X, Factory } from "lucide-react";

export default function AdminSuppliers() {
  const [suppliers, setSuppliers] = useState([]);
  const load = () => api.get("/admin/suppliers").then((r) => setSuppliers(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const act = async (id, action) => {
    try {
      await api.post(`/admin/suppliers/${id}/${action}`);
      toast.success(`Supplier ${action}d`);
      load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="p-6 md:p-8 max-w-7xl">
      <div className="label-tech text-muted-foreground mb-1">Verification</div>
      <h1 className="text-3xl font-bold tracking-tight">Suppliers</h1>

      <div className="mt-6 border border-border rounded-sm overflow-hidden bg-card">
        <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 border-b border-border label-tech text-muted-foreground bg-secondary/50">
          <div className="col-span-4">Company / Contact</div>
          <div className="col-span-3">Email</div>
          <div className="col-span-2">Joined</div>
          <div className="col-span-1">Status</div>
          <div className="col-span-2 text-right">Actions</div>
        </div>
        {suppliers.length === 0 && <div className="px-5 py-12 text-center text-sm text-muted-foreground">No suppliers registered yet.</div>}
        {suppliers.map((s) => (
          <div key={s.id} data-testid={`supplier-row-${s.id}`} className="grid grid-cols-2 md:grid-cols-12 gap-2 md:gap-4 px-5 py-4 border-b border-border last:border-0 items-center">
            <div className="col-span-2 md:col-span-4 flex items-center gap-3 min-w-0">
              <div className="h-9 w-9 bg-secondary grid place-items-center rounded-sm shrink-0"><Factory className="h-4 w-4 text-muted-foreground" /></div>
              <div className="min-w-0">
                <div className="font-medium truncate">{s.company || s.name}</div>
                <div className="text-xs text-muted-foreground truncate">{s.name}</div>
              </div>
            </div>
            <div className="hidden md:block col-span-3 text-sm text-muted-foreground truncate">{s.email}</div>
            <div className="hidden md:block col-span-2 text-xs text-muted-foreground">{fmtDate(s.created_at)}</div>
            <div className="col-span-1"><StatusBadge status={s.supplier_status} /></div>
            <div className="col-span-2 flex justify-end gap-2">
              {s.supplier_status !== "approved" && (
                <button data-testid={`approve-supplier-${s.id}`} onClick={() => act(s.id, "approve")} className="inline-flex items-center gap-1 px-3 py-1.5 bg-emerald-600 text-white rounded-sm text-xs hover:bg-emerald-700 transition-colors">
                  <Check className="h-3.5 w-3.5" /> Approve
                </button>
              )}
              {s.supplier_status !== "rejected" && (
                <button data-testid={`reject-supplier-${s.id}`} onClick={() => act(s.id, "reject")} className="inline-flex items-center gap-1 px-3 py-1.5 border border-border rounded-sm text-xs hover:bg-destructive hover:text-destructive-foreground hover:border-destructive transition-colors">
                  <X className="h-3.5 w-3.5" /> Reject
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
